/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');
const DialogRenderer = require('../renderers/DialogRenderer.jsx');
const MessagingSection = React.createClass({

 
  showDialog() {
    this.refs.quickturnDialog.showDialog();
  },

  render() {
    let quickturnDialogTitle = _.get(this.props.productData.product, 'metadata.QuickturnDialogTitle');
    let quickturnDialogContent = _.get(this.props.productData.product, 'metadata.QuickturnDialogContent');
    let holidayCutoffMessaging = _.get(this.props.productData.product, 'metadata.HolidayCutoffMessaging');
    let holidayCutoffDates = _.get(this.props.productData.product, 'metadata.HolidayCutoffDates');
    if (holidayCutoffMessaging && holidayCutoffDates) {
      let today = new Date();
      today.setHours(0,0,0,0);
      let StartDate = new Date(holidayCutoffDates.StartDate);
      let EndDate = new Date(holidayCutoffDates.EndDate);
      let inRange = (today >= StartDate && today <= EndDate);
      holidayCutoffMessaging = inRange ?
        (<div className="uc-holiday-cutoff-messaging" dangerouslySetInnerHTML={{__html: holidayCutoffMessaging}} />) : null;
    } else {
      holidayCutoffMessaging = null;
    }
    let productQuickturnMessaging = _.get(this.props.productData.product, 'metadata.ProductQuickturnMessaging');
    if (productQuickturnMessaging) {
      productQuickturnMessaging = (
        <div className="uc-quickturn-messaging">
          <div style={{display: 'inline'}} dangerouslySetInnerHTML={{__html: productQuickturnMessaging}} />
          <i className="wmicon wmicon-help" onClick={this.showDialog}> </i>
        </div>
      );
    }
    let productMessaging = _.get(this.props.productData.product, 'metadata.ProductMessaging');
    if (productMessaging) productMessaging = (
      <div className="uc-messaging" dangerouslySetInnerHTML={{__html: productMessaging}} />);
    return (
      <div>
        { holidayCutoffMessaging }
        { productQuickturnMessaging }
        { productMessaging }
        <DialogRenderer
          ref="quickturnDialog"
          title={quickturnDialogTitle}
          buttons={[{text: 'OK', btnClass: 'uc-primary-btn'}]}
          containerStyle={{
            paddingTop: '10px'
          }}>
          <div dangerouslySetInnerHTML={{__html: quickturnDialogContent}} />
        </DialogRenderer>
      </div>
    );
  }
});

module.exports = MessagingSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/MessagingSection.jsx